import { useQuery } from "@tanstack/react-query";
import { ONE_MINUTE_MS } from "../utils/time";
import { QUERY_KEYS } from "./constants";
import { useAuthApiClient } from "./useAuthApiClient";
import { usePortalApiClient } from "./usePortalApiClient";
export function useGetCurrentAccount(queryOptions = {}) {
    const authApiClient = useAuthApiClient();
    const portalApiClient = usePortalApiClient();
    return useQuery({
        queryKey: [QUERY_KEYS.ACCOUNT, QUERY_KEYS.CURRENT],
        queryFn: async () => {
            const currentAccount = await authApiClient.getCurrentAccount();
            const linkedWallets = currentAccount?.linkedAccounts?.filter((account) => account.type === "wallet");
            if (!linkedWallets || linkedWallets.length === 0) {
                return {
                    ...currentAccount,
                    mats: {
                        totalMats: 0,
                    },
                };
            }
            const addresses = linkedWallets.map((account) => account.btcAddress || account.evmAddress);
            const mats = await Promise.all(addresses.map((address) => portalApiClient.getPortalMats(address)));
            const totalMats = mats.reduce((sumMats, currentMats) => sumMats + currentMats.totalMats, 0);
            return {
                ...currentAccount,
                mats: {
                    totalMats,
                },
            };
        },
        staleTime: ONE_MINUTE_MS,
        retry: 1,
        ...queryOptions,
    });
}
//# sourceMappingURL=useGetCurrentAccount.js.map